@use "../../../globals/bcp-2022/common/cms-content" as cms;
@use "../../../globals/bcp";

f-cms-content {
  .f-cms-content {
    @include cms.cms-content();
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
